import AbstractChannel from './AbstractChannel'

export default class PurchasePark2Fly extends AbstractChannel {

  name = 'pp2f'
  title = 'Purchase Park 2 Fly'
  titleShort = 'PP2F'
  color = '#17becf'

  supportedFeatures = ['blackouts']

}
